export default __webpack_public_path__ + "assets/validate-paper.svg";